import { Stack } from "@mui/material";
import MenuPopover from "src/components/MenuPopover";

import LanguagePopoverItems from "./LanguagePopoverItems";

// ----------------------------------------------------------------------

type Props = {
	open: HTMLElement | null;
	onClose: () => void;
};

export default function Menu({ open, onClose }: Props) {
	return (
		<MenuPopover
			anchorEl={open}
			onClose={onClose}
			open={Boolean(open)}
			sx={{
				mt: 1.5,
				ml: 0.75,
				width: 180,
				"& .MuiMenuItem-root": {
					px: 1,
					typography: "body2",
					borderRadius: 0.75
				}
			}}
		>
			<Stack spacing={0.75}>
				<LanguagePopoverItems onClick={onClose} />
			</Stack>
		</MenuPopover>
	);
}
